import { RecommendedAccountItemProps } from '@components/report/recommended-account-item/RecommendedAccountItem';

import { IGAccountRes, IGReportRes } from '@apis/orval/model';

import { RecommendationProps } from './Recommendations';

export class RecommendationAdapter {
	value: IGReportRes;

	constructor(obj: IGReportRes) {
		this.value = obj;
	}

	get recommendations() {
		return this.value?.account_recommendations?.instagram_recommendation_accounts ?? [];
	}

	getCategoriesFromAccount(item: IGAccountRes): string[] {
		const category1 = item?.category_1 ?? '';
		const category2 = item?.category_2 ?? '';

		return [category1, category2].filter((v) => v) as string[];
	}

	getRecommendedAccountItemProps(item: IGAccountRes): RecommendedAccountItemProps {
		return {
			userName: item?.profile?.username ?? undefined,
			fullName: item?.profile?.full_name ?? undefined,
			src: item?.profile?.profile_img_link ?? undefined,
			categories: this.getCategoriesFromAccount(item),
			followers: item?.profile?.follower ?? undefined,
			realFollowers: item?.profile?.real_follower ?? undefined,
			outLink: item?.profile?.platform_pk
				? `/report/instagram/${item.profile.platform_pk}`
				: undefined,
		};
	}

	adapt(): RecommendationProps {
		return {
			accounts: this.recommendations.map((item) =>
				this.getRecommendedAccountItemProps(item),
			),
		};
	}
}
